import React, { useState, useRef, useEffect } from "react";
import styled, { css } from "styled-components";

const CheckBoxLabel = styled.label`
	width: 60px;
	border-radius: 15px;
	margin-right: 0.5rem;
	cursor: pointer;
	background-color: ${({ active, bgColor, theme }) =>
		active ? (bgColor ? bgColor : theme.colors.primary) : "#ddd"};
	&::after {
		content: "";
		display: block;
		border-radius: 50%;
		height: 23px;
		width: 23px;
		margin: ${({ active }) => (active ? "3px 3px 3px 33px" : "3px")};
		background: ${({ active, theme }) =>
			active ? theme.colors.white : theme.colors.darkgrey};
		box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
		transition: all 0.2s ease;
	}
`;
const CheckBox = styled.input.attrs(({ disabled, active }) => ({
	disabled: disabled ? disabled : "",

	active: active ? active : false,
}))`
	opacity: 0;
	z-index: -1;
	width: 23px;
	border-radius: 15px;
	position: absolute;
	height: 23px;
	&:focus + label {
		outline: 2px dashed #515151;
	}

	&:disabled + ${CheckBoxLabel} {
		background-color: ${({ theme }) => theme.colors.grey};
		cursor: not-allowed;

		&::after {
			background: ${({ theme }) => theme.colors.white};
			content: "";
			display: block;
			border-radius: 50%;
			width: 23px;
			height: 23px;
			margin-left: 33px;
			transition: 0.2s ease;
		}
	}
`;
const Flex = styled.div`
	display: flex;
	padding: 0.5rem 0;
	margin: ${({ margin }) => margin};
	align-items: center;
`;

export const ToggleCheckbox = ({
	bgColor,
	label,
	disabled,
	isSet,
	onChangeFunc,
	hidden,
	margin,
}) => {
	const [active, set] = useState(isSet);
	const checkBoxRef = useRef(null);

	const onChange = () => {
		set(!active);
		onChangeFunc();
	};
	const handleKeyPress = (e) => {
		if (e.key === "Enter" || e.key === " ") {
			onChange();
		}
	};
	useEffect(() => {
		set(isSet);
	}, [isSet]);

	return (
		<Flex margin={margin}>
			<CheckBox
				tabIndex={hidden ? "-1" : "0"}
				onKeyPress={(e) => handleKeyPress(e)}
				disabled={disabled}
				aria-label={label}
				id={label}
				type="checkbox"
				ref={checkBoxRef}
			/>
			<CheckBoxLabel
				active={active}
				bgColor={bgColor}
				htmlFor={label}
				onClick={() => onChange()}
			/>
			<span>{label}</span>
		</Flex>
	);
};
